import { render, staticRenderFns } from "./Cut.vue?vue&type=template&id=704bbda9&scoped=true&"
import script from "./Cut.vue?vue&type=script&lang=js&"
export * from "./Cut.vue?vue&type=script&lang=js&"
import style0 from "./Cut.vue?vue&type=style&index=0&id=704bbda9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704bbda9",
  null
  
)

export default component.exports